import { supabase } from "../../client";
import { useNavigate } from "react-router-dom";

// Custom hooks
import useSessionManager from "./useSessionManager";

const useLogOut = () => {
  const sessionManager = useSessionManager();
  const navigate = useNavigate();

  const logOut = async () => {
    try {
      await supabase.auth.signOut();
      sessionManager.remove();
      navigate("/");
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  return logOut;
};

export default useLogOut;
